import React from 'react';
export function StatsBar() {
  return <section className="bg-blue-600 text-white py-6 px-4" data-id="element-200">
      <div className="max-w-4xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-6 text-center" data-id="element-201">
        <div data-id="element-202">
          <p className="text-3xl font-extrabold" data-id="element-203">+1.500</p>
          <p className="text-sm text-blue-100" data-id="element-204">Docentes en todo el país</p>
        </div>
        <div data-id="element-205">
          <p className="text-3xl font-extrabold" data-id="element-206">12</p>
          <p className="text-sm text-blue-100" data-id="element-207">Tomos listos para usar</p>
        </div>
        <div data-id="element-208">
          <p className="text-3xl font-extrabold" data-id="element-209">4.9/5 ⭐</p>
          <p className="text-sm text-blue-100" data-id="element-210">Calificación promedio</p>
        </div>
        <div data-id="element-211">
          <p className="text-3xl font-extrabold" data-id="element-212">🇦🇷</p>
          <p className="text-sm text-blue-100" data-id="element-213">Prim. y Sec. — Todo el país</p>
        </div>
      </div>
    </section>;
}